import _ from "lodash";
import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import * as actions from "data/mediagroups/actions";
import MenuLink from "components/Navigation/MenuLink";

import ActionDelete from "material-ui/svg-icons/action/delete";

import { Page, PageBlock, RightDrawer } from "components/Page";

import Subheader from "material-ui/Subheader";
import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow
} from "material-ui/Table";
import ClickableRowColumn from "components/Grid/ClickableRowColumn";
import ClickableRow from "components/Grid/ClickableRow";

import RaisedButton from "material-ui/RaisedButton";
import ContentAdd from "material-ui/svg-icons/content/add";
import * as os from "osutil";

class MediagroupPage extends Component {
  state = { selected: [] };

  static contextTypes = {
    router: PropTypes.object
  };

  componentWillMount() {
    this.props.fetchMediagroups();
  }

  handleDeleteClick = id => {
    this.props.deleteMediagroup(id);
  };

  handleEditClick = id => {
    this.context.router.history.push("/admin/mediagroup/" + id);
  };

  addMediagroup = e => {
    this.props.createMediagroup(
      { name: "New mediagroup" },
      this.handleEditClick
    );
  };

  deleteMediagroups = e => {
    _.each(this.state.selected, p => this.props.deleteMediagroup(p.key));
  };

  onRowSelection = rows => {
    var selected = rows.map(i => this.props.mediagroups[i]).filter(r => !!r);
    this.setState({ selected: selected });
  };

  renderMediagroups() {
    return _.map(this.props.mediagroups, mediagroup => {
      return (
        <ClickableRow
          key={mediagroup.key}
          onMyRowClick={() => this.handleEditClick(mediagroup.key)}
        >
          <ClickableRowColumn>{mediagroup.name}</ClickableRowColumn>
          <ClickableRowColumn>{mediagroup.description}</ClickableRowColumn>
          <ClickableRowColumn>{mediagroup.url}</ClickableRowColumn>
        </ClickableRow>
      );
    });
  }
  render() {
    return [
      <RightDrawer key="right">
        <PageBlock label="Mediehus" />
        <div>
          <RaisedButton onClick={this.addMediagroup}>Skapa nytt</RaisedButton>
        </div>
      </RightDrawer>,
      <Page key="page" ready={!this.props.pending}>
        <Table>
          <TableHeader displaySelectAll={false}>
            <TableRow>
              <TableHeaderColumn>Namn</TableHeaderColumn>
              <TableHeaderColumn>Beskrivning</TableHeaderColumn>
              <TableHeaderColumn>URL</TableHeaderColumn>
            </TableRow>
          </TableHeader>
          <TableBody displayRowCheckbox={false}>
            {this.renderMediagroups()}
          </TableBody>
        </Table>
      </Page>
    ];
  }
}

function mapStateToProps(state) {
  return {
    mediagroups: os.collection_to_array(state.mediagroups.list.data),
    pending: state.mediagroups.list.pending
  };
}

export default connect(mapStateToProps, actions)(MediagroupPage);



// WEBPACK FOOTER //
// ./src/pages/admin/mediagroups/Mediagroups.jsx